import { Form, Head } from "@inertiajs/react"

import InputError from "@/components/input-error"
import { Button } from "@/components/ui/button"
import { Input } from "@/components/ui/input"
import { Label } from "@/components/ui/label"
import { Spinner } from "@/components/ui/spinner"
import AuthLayout from "@/layouts/auth-layout"
import { identityPasswordResetPath } from "@/routes"

interface ResetPasswordProps {
  sid: string
  email: string
}

export default function ResetPassword({ sid, email }: ResetPasswordProps) {
  return (
    <AuthLayout
      title="Reset password"
      description="Please enter your new password below"
    >
      <Head title="Reset password" />
      <div className="p-6">
        <Form
          method="put"
          action={identityPasswordResetPath()}
          transform={(data) => ({ ...data, sid, email })}
          resetOnSuccess={["password", "password_confirmation"]}
        >
          {({ processing, errors }) => (
            <div className="grid gap-6">
              <div className="grid gap-2">
                <Label htmlFor="email">Email</Label>
                <Input
                  id="email"
                  type="email"
                  name="email"
                  autoComplete="email"
                  value={email}
                  className="mt-1 block w-full"
                  readOnly
                />
                <InputError messages={errors.email} className="mt-2" />
              </div>

              <div className="grid gap-2">
                <Label htmlFor="password">Password</Label>
                <Input
                  id="password"
                  type="password"
                  name="password"
                  autoComplete="new-password"
                  className="mt-1 block w-full"
                  autoFocus
                  placeholder="Password"
                />
                <InputError messages={errors.password} />
              </div>

              <div className="grid gap-2">
                <Label htmlFor="password_confirmation">Confirm password</Label>
                <Input
                  id="password_confirmation"
                  type="password"
                  name="password_confirmation"
                  autoComplete="new-password"
                  className="mt-1 block w-full"
                  placeholder="Confirm password"
                />
                <InputError
                  messages={errors.password_confirmation}
                  className="mt-2"
                />
              </div>

              <Button
                type="submit"
                className="mt-4 w-full"
                disabled={processing}
              >
                {processing && <Spinner />}
                Reset password
              </Button>
            </div>
          )}
        </Form>
      </div>
    </AuthLayout>
  )
}
